import { render } from "./PieChartBox.vue?vue&type=template&id=793051a8"
import script from "./PieChartBox.vue?vue&type=script&lang=js"
export * from "./PieChartBox.vue?vue&type=script&lang=js"
script.render = render

export default script